import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../../theme'
// material components
import Typography from '@mui/material/Typography'
import Radio from '@mui/material/Radio';

const styles = {
    root: {
        width: "auto",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            width: "auto",
            margin: '0 px 5px 0',
        },
    },
    checkbox: {
        'width': 15,
        'height': 15,
        'marginTop': 3,
        '&$checked': {
            color: theme.palette.primary.dark,
        },
    },
    checked: {},
    label: {
        margin: '5px 0',
        fontSize:10,
        color: theme.palette.secondary.dark,
    },
}

/**
 * component for mode (sidebar)
 * @param classes
 * @param icon
 * @param label
 * @param checked
 * @param handleCheckboxChange
 * @returns {*}
 * @constructor
 */
const ModeItem = ({ classes, icon, label, checked, handleCheckboxChange, style, nowrap }) => (
        <div style={{...styles.root, style}}>
            {icon}
             <Typography variant={'caption'} style={styles.label} nowrap={nowrap} align={"center"}>
                 {label}
             </Typography>
             <Radio
                 classes={{
                     root: styles.checkbox,
                     checked: styles.checked,
                 }}
                style={{
                    color: theme.palette.primary.dark,
                    '&.Mui-checked': {
                    color: theme.palette.primary.dark,
                    }}
                }

                 checked={checked}
                 onClick={ handleCheckboxChange }
                 value={label}
                 aria-label={label}
             />
        </div>
    )

ModeItem.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    style: PropTypes.object,
    nowrap: PropTypes.bool
}

export default ModeItem
